import { useCallback } from 'react';
import { useGetEmissorContractConfigsQuery, useUpdateEmissorContractConfigsMutation, } from '../services/contractConfigsApi';
import { useDeductionLineConfig } from './useDeductionLineConfig';
export function useEmissorContractConfig(contractId, enabled) {
    const query = useGetEmissorContractConfigsQuery({ contractId: contractId ?? '' }, { skip: !contractId || !enabled, refetchOnMountOrArgChange: true });
    const [updateConfigs, { isLoading: isSaving }] = useUpdateEmissorContractConfigsMutation();
    const persist = useCallback(async (config, nextIsEnabled) => {
        await updateConfigs({
            contractId: contractId ?? '',
            configs: [{ config: config.config, isEnable: nextIsEnabled }],
        }).unwrap();
    }, [contractId, updateConfigs]);
    return useDeductionLineConfig({
        query,
        isSaving,
        enabled,
        canPersist: Boolean(contractId),
        persist,
    });
}
